import { HeaderOverview } from "components";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
} from "../..";
import { useOverview } from "providers/overview";
import { useAppLanguage } from "providers/app-language";
import { Form } from "antd";
import { useGetPropertyDashboardAppliancesCountMost } from "service/dashboard/property/appliances";

const MostUser = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();
  const { translationObject } = useAppLanguage();

  const workSpaceDate = Form.useWatch("workSpaceDate");
  const date = findDate(workSpaceDate);

  const { data, isFetching, isError, error } =
    useGetPropertyDashboardAppliancesCountMost({
      ...date,
    });

  const { name } = translationObject({ object: data?.[0], keys: ["name"] });

  return (
    <WrapperBG className="h-full">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("items-that-have-most-users")}
          name="workSpaceDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="250px" />
        ) : !data || data.length <= 0 ? (
          <NoDataDashboard height="250px" />
        ) : (
          <div className="h-[250px] center flex-col">
            <div className="text-[2.5rem] text-[#44955B]">{name}</div>
          </div>
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default MostUser;
